import ko from 'knockout';
 
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import { stringToDate } from '../../../utils/date';

export default function LoadLevelingViewModel(model) {
    var mapping = {
        LoadLevelProcessDate: {
            create: function(options) {
                return Date.parse(stringToDate(options.data, null, true)).toString(
                    'dddd MMMM d, yyyy'
                );
            }
        },
        LoadLevelShipDate: {
            create: function(options) {
                return Date.parse(stringToDate(options.data, null, true)).toString(
                    'dddd MMMM d, yyyy'
                );
            }
        }
    };

    ko.mapping.fromJS(model, mapping, this);
}

